import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_40000621_55235)">
        <path
          d="M2.5 7.49999L5.83333 4.16666M5.83333 4.16666L9.16667 7.49999M5.83333 4.16666V15.8333"
          stroke="#707A8F"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4999 12.5L14.1666 15.8333M14.1666 15.8333L10.8333 12.5M14.1666 15.8333V4.16666"
          stroke="#707A8F"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_40000621_55235">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgComponent;
